
export default {
  name: "ActivityIconToggler",
  props: {
    expanded: Boolean,
    claimsHtml: String
  }
};
